<div class="card">
  <div class="text-center">
    <img src="/assets/images/boldungu_logo.png" alt="Avatar" style="width:50%">
  </div> 
    <div class="container text-center mt-5">
      <h4><b>Ready to rock and roll with mathematics!.</b></h4>
      <p>Check your email and login with the new password. </p>
    </div>
  </div> 
